module.exports = __webpack_public_path__ + "static/media/Image1.23072dfd.JPG";